import React, { useEffect, useState } from 'react';
import { RPCFactory } from '../../../utils/RequestUtil';
import useList from '../../hooks/useList';
import { Column, Table, PageBar, Loading } from '@tencent/spaui';
import {
  LeadsSource,
  LeadsOperationType,
  // LeadsComeFrom,
} from '../../../consts/leadsLogs';

const Page = (props) => {
  const recordListHooks = useList({ data: [] });

  const [pageIndex, setPageIndex] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [totalSize, setTotalSize] = useState(0)
  const [tableLoading, setTableLoading] = useState(false)


  /**
     * 页码点击
     * @param event
     * @param value
     */
  const onChangePageIndex = (event, value) => {
    setPageIndex(value)
    getList(pageSize, value);
  };

  /**
   * 页面条目数量点击
   * @param event
   * @param value
   */
  const onChangePageSize = (event, value) => {
    setPageSize(value)
    getList(value, pageIndex);
  };
  const getList = (size, index) => {
    setTableLoading(true)
    RPCFactory.leadsManage
      // .getLog(props.detailAdvertiserId || window.pageProps.uid, props.leadsId, size, index)
      .getLog({
        queryAccountId: props.detailAdvertiserId || window.pageProps.uid,
        accountId: window.pageProps.uid,
        leadsIds: JSON.stringify([props.leadsId]),
        pageSize: size,
        pageIndex: index
      })
      .done((data) => {
        recordListHooks.setDataList(data.entities);
        setTotalSize(data.size)
        setTableLoading(false)

      })
      .fail((ret, msg) => {
        alert(`请求失败，msg:${msg}`);
        setTableLoading(false)
      });
  }
  useEffect(() => {
    getList(pageSize, pageIndex)
  }, []);
  const renderSource = (type, name, value, data) => {
    if (type !== 'head') {
      return LeadsSource[data.source];
    }
    return <div>操作端</div>;
  };
  const renderTypeName = (type, name, value, data) => {
    if (type !== 'head') {
      return LeadsOperationType[data.operateType] || '-';
    }
    return <div>操作类型</div>;
  }
  return (
    <div className="follow-calling">
      <div className="datalist">
        {tableLoading ? <Loading /> :
          <Table data={recordListHooks.dataList}>
            <Column name="operationTypeName" render={renderTypeName}>操作类型</Column>
            <Column name="detail">操作内容</Column>
            <Column name="name">操作人</Column>
            <Column name="source" render={renderSource} width={100}>操作端</Column>
            <Column name="createdTime" width={150}>操作时间</Column>
          </Table>
        }
      </div>
      <PageBar
        value={pageIndex}
        pageSize={pageSize}
        totalSize={totalSize}
        pageSizeList={[5, 10, 20]}
        onChange={onChangePageIndex}
        onPageSizeChange={onChangePageSize}
      />
    </div>
  );
};

export default Page;
